import { ReloadOutlined, SaveFilled, UploadOutlined } from '@ant-design/icons';
import { Button, Form } from 'antd';
import dayjs from 'dayjs';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import { HAPUS_IFUNDEFINE } from 'services';
import _Api from 'services/Api/_Api';
import { Date_, TitleBar } from 'services/Forms/Forms';
import { Button_, Input_, Number_ } from 'services/Forms/FormsSatu';
import { msg } from 'services/Toastr/Notify/_Toastr';

function PerhitunganEnergyAnak(pr) {

  const [data, setdata] = useState({})
  const FORM_ID = 2
  const KONSELING_ID = pr.konseling_id

  const getCombo = () => {
    _Api.get("/get-combo-form?form_id=" + FORM_ID + "&konseling_id=" + KONSELING_ID).then(res => {
      // setcombo(res)
      var dt = res.data.combo
      var rc = res.data.record
      setdata(rc)
      // setlistDiet(res.data.listdiet)


      // frm.setFieldsValue(rc)

      var initfield = {}

      rc.map(gg => {
        if (gg.tipedata == "checkbox") {
          initfield.centang = { ...initfield.centang, [gg.fiel_fk]: gg.value == 1 }
        } else
          if (gg.tipedata == "textbox") {
            initfield[gg.fiel_fk] = gg.value
          } else
            if (gg.tipedata == "int") {
              initfield[gg.fiel_fk] = parseInt(gg.value)
            } else
              if (gg.tipedata == "date") {
                initfield[gg.fiel_fk] = moment(gg.value)
              } else
                if (gg.tipedata == "multiple" && gg.value != undefined) {
                  var vlll = gg.value.split(",")
                  initfield[gg.fiel_fk] = vlll
                }
      })
      frm.setFieldsValue(initfield)

      setTimeout(() => {
        hitungBMR()
      }, 300);
    })

  }


  const [frm] = Form.useForm();

  const dataFields = [
    { label: "Nama", field: "nama", disabled: true },
    { label: "Jenis Kelamin", field: "jeniskelamin_id", satuan: " L / P", disabled: true },
    // { label: "Tanggal Lahir", field: "tgllahir", satuan: "", tipe: "date", disabled: true },
    { label: "Usia", field: "umur", disabled: true, satuan: "tahun", disabled: true },
    { label: "Berat Badan", field: "bb", satuan: "kg", disabled: true, tipe: "int" },
    { label: "Tinggi Badan", field: "tb", satuan: "cm", disabled: true, tipe: "int" },
    { label: "BMR", field: "bmr", satuan: "kkal", disabled: true },
    { label: "Faktor Aktivitas", field: "faktor_aktivitas" ,tipe: "int" },
    { label: "Faktor Stress", field: "faktor_stress" },
    { label: "TEE", field: "tee", satuan: "kkal", disabled: true, },
  ];


    const simpanData = () => {
        // setloading(true)
        // console.log(val)
        // debugger
        frm.validateFields().then(val => {
            var pure = HAPUS_IFUNDEFINE(val)
            // delete cek.centang
            var obj = {
                konseling_id: KONSELING_ID,
                form_id: FORM_ID,
                // diet : ,
                data: {
                    ...pure,
                    // ...cheklist, 
                    // diet: pure.diet && pure.diet.length > 0 ? pure.diet.toString() : "",
                    // diitsebelumnya: pure.diitsebelumnya && pure.diitsebelumnya.length > 0 ?  pure.diitsebelumnya.toString() :"",
                }
            }
            delete obj.data.centang
            _Api.post("simpan-form-konseling", obj).then(rs => {
                msg.auto(rs.data)
                // setloading(false)

            })
        }).catch(err => {
            // setloading(false)
            msg.error("Silahkan lengkapi data ")
        })
    }


  // const hitungUmur = () => {
  //   var tgl = frm.getFieldValue("tgllahir")
  //   var umur = dayjs  ().diff(tgl, 'year').toString()
  //   frm.setFieldsValue({ "usia": umur })

  //   hitungBMR()
  // }

  const getNumber = (field) => {
    const raw = frm.getFieldValue(field)
    if (raw === undefined || raw === null || raw === '') return 0
    return parseFloat(String(raw).replace(/,/g, '')) || 0
  }

  const formatRibuan = (val) => {
    if (val === undefined || val === null || isNaN(val)) return "0"
    return Number(val).toLocaleString('en-US', { maximumFractionDigits: 2 })
  }

  const hitungBMR = () => {

    const B12 = getNumber("tb")
    const B11 = getNumber("bb")
    const JK = frm.getFieldValue("jeniskelamin_id") ?? ""
    const Umur = getNumber("umur")

    var L0_3 = (0.167 * B11) + (1517.4 * B12 / 100) - 617.6
    var P0_3 = (16.25 * B11) + (1023.2 * B12 / 100) - 413.5
    var BMR0_3 = JK == "L" ? L0_3 : P0_3


    var L4_10 = (19.6 * B11) + (130.3 * B12 / 100) + 414.9
    var P4_10 = (16.97 * B11) + (161.8 * B12 / 100) + 371.2
    var BMR4_10 = JK == "L" ? L4_10 : P4_10

    // frm.setFieldsValue({ bmr4_10: BMR4_10 })

    var L11_18 = (16.25 * B11) + (137.2 * B12 / 100) + 515.5
    var P11_18 = (8.365 * B11) + (465 * B12 / 100) + 200
    var BMR11_18 = JK == "L" ? L11_18 : P11_18

    // hitung MBR
    var BMR = Umur <= 3 ? BMR0_3 : Umur <= 10 ? BMR4_10 : BMR11_18

    var TEE = BMR * getNumber("faktor_aktivitas") * getNumber("faktor_stress")


    frm.setFieldsValue({
      bmr0_3: formatRibuan(BMR0_3),
      L0_3: formatRibuan(L0_3),
      P0_3: formatRibuan(P0_3),
      P4_10: formatRibuan(P4_10),
      L4_10: formatRibuan(L4_10),
      bmr4_10: formatRibuan(BMR4_10),
      L11_18: formatRibuan(L11_18),
      P11_18: formatRibuan(P11_18),
      bmr11_18: formatRibuan(BMR11_18),
      bmr: formatRibuan(BMR),
      tee: formatRibuan(TEE),
    })


  }


  useEffect(() => {

    getCombo()
  }, [pr])

  return (
    <div>
      <h1 className='text-center text-uppercase b'> Perhitungan Energi Anak </h1>
      <Form form={frm} layout='horizontal'
        labelCol={{
          span: 6,
        }}
        wrapperCol={{
          span: 17,
        }}
      >
        <Row>
          <Col sm={8} className='border p-2'>
            <h5> &nbsp;  </h5>
            {
              dataFields.map((v, i) => {
                if (v.tipe == "int") {
                  return (
                    <Row key={i}>
                      <Number_  name={v.field} disabled={v.disabled} label={v.label}   addonAfter={v.satuan} />
                    </Row>
                  )
                } else
                  return (
                    <Row key={i}>
                      <Input_ onChange={hitungBMR} name={v.field} disabled={v.disabled} label={v.label} addonAfter={v.satuan} />
                    </Row>
                  )
              })
            }
            <br/>
            <center>
              <Button_ sm="2" color="green" icon={<ReloadOutlined />} block title="Hitung Ulang" onClick={hitungBMR} />
            </center>

          </Col>
          <Col sm={4} className='border p-2'>
            <h5> BMR (Basal Metabolic Rate) </h5>
            <TitleBar label='Perhitungan BMR 0-3 tahun (Schofield, 2005)' />
            <br />
            <Input_ label='Laki-laki' readOnly name='L0_3' />
            <Input_ maxLength="1" label='Perempuan' readOnly name='P0_3' />
            <Input_ label='BMR 0-3 Tahun' readOnly name='bmr0_3' />

            <TitleBar label='Perhitungan BMR 4-10 tahun (Schoname, 2005)' />
            <br />
            <Input_ label='Laki-laki' readOnly name='L4_10' />
            <Input_ label='Perempuan' readOnly name='P4_10' />
            <Input_ label='BMR 4-10 Tahun' readOnly name='bmr4_10' />

            <TitleBar label='Perhitungan BMR 11-18 tahun (Schoname, 2005)' />
            <br />
            <Input_ label='Laki-laki' readOnly name='L11_18' />
            <Input_ label='Perempuan' readOnly name='P11_18' />
            <Input_ label='BMR 11-18 Tahun' readOnly name='bmr11_18' />


          </Col>

        </Row>
        {/* <Button_ label="Simpan" size="large" sm={3} block icon={<UploadOutlined />} onClick={simpanData} /> */}
      </Form>


      <div className='fixed-bawah'>
        <Row>
          <Button_ sm="2" icon={<UploadOutlined />} block title="Simpan" onClick={simpanData} />
          <Button_ color="orange" sm="2" icon={<ReloadOutlined />} block title="Refresh" onClick={getCombo} />

          <Col></Col>
        </Row>
      </div>

    </div >
  )
}

export default PerhitunganEnergyAnak
